import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Link from 'react-router';
import actions from '../../actions';
import _ from 'lodash';
import {
	Corporation,
	SearchBar,
	EntityList,
	Pagination,
	Loader,
} from './../../components';

const DEFAULT_LIMIT = 10;

class CorpList extends Component {

	constructor(props) {
		super(props);

		const limit = this.props.location.query.limit || DEFAULT_LIMIT;
		let offset = 0;

		// If a page is set then calculate the offset
		if (this.props.location.query.page) {
			offset = (parseInt(this.props.location.query.page, 10) - 1) * limit;
		}

		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleSearchClick = this.handleSearchClick.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			limit,
			offset,
			filter: this.props.location.query.filter || '',
		};
	}

	componentDidMount() {
		this.fetchCorporationList();
	}

	componentWillReceiveProps(nextProps) {

		const newState = {};

		// Check if the page has changed.
		if (this.props.location.query.page !== nextProps.location.query.page) {

			if (nextProps.location.query.page) {
				newState.offset = (parseInt(nextProps.location.query.page, 10) - 1) * this.state.limit;
			} else {
				newState.offset = 0;
			}

		}

		// Check if the filter has changed.
		if (this.props.location.query.filter !== nextProps.location.query.filter) {

			newState.filter = nextProps.location.query.filter || '';

		}

		// Check if we should set the new state and reload the corporation list
		if (Object.keys(newState).length) {
			this.setState(newState, this.fetchCorporationList);
		}

	}

	fetchCorporationList () {

		this.props.actions.fetchCorpList({
			offset: this.state.offset,
			limit: this.state.limit,
			filter: this.state.filter,
			withFeeds: true,
			withSubdivisionCounts: true,
			withbuilderCounts: true,
		});

	}

	handleSearchClick(filter) {

		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page: 1,
				filter,
			},
		});

	}

	handleRowClick(corporation) {
		return (e) => {
			e.preventDefault();
			browserHistory.push({ pathname: '/corporations/' + corporation.id, state: { pathInfo: [{id: corporation.id.toString(), name: corporation.name }]}});
			this.props.actions.receiveCorp(corporation);
		}
	}

	onPageChange(page) {

		browserHistory.push({
			...this.props.location,
			query: { ...this.props.location.query, page },
		});

	}

	render() {
		let corpList = _.map(this.props.corporations, (c) => {
			return <Corporation key={c.id} corporation={c} onClick={this.handleRowClick(c)}/>;
		});

		if (corpList.length == 0) { corpList = <div>No results found.</div>; }

		return (
			<div className="wrapper">
				<div className="container corporation-list">
					<div className='row row-align-center'>
						<div className='cell'>
							<h1>Corporations</h1>
						</div>
						<div className='cell justify-center'>
							<Loader visible={this.props.isFetching} />
						</div>
						<div className='cell justify-right'>
							<SearchBar value={this.state.filter} onEnter={this.handleSearchClick}/>
						</div>
					</div>
					<EntityList children={corpList} />
					<If condition={this.props.pagination}>
						<Pagination totalPages={this.props.pagination.pages.total}
							currentPage={this.props.pagination.pages.current}
							onPageChange={this.onPageChange}/>
					</If>
				</div>
			</div>
		);
	}

}

CorpList.propTypes = {
	// Injected by React Redux
	error: PropTypes.object,
	// Injected by React Router
	children: PropTypes.node
};

export default connect(
	state => {
		return {
			error: state.corporations.error,
			corporations: state.corporations.corpList,
			isFetching: state.corporations.isFetching,
			pagination: state.corporations.pagination,
		};
	},
	dispatch => {
		return {
			actions: bindActionCreators(actions.corporations, dispatch),
		};
	})(CorpList);



// WEBPACK FOOTER //
// ./src/assets/js/containers/corporations/List.js